import { roundToSignificant } from "utils/roundToSignificant";
import { DataTableStoreState } from "../store/DataTableProvider.types";
import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiText,
} from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";

interface DataTableComputeCreditsProps {
  selectedTable: Extract<
    DataTableStoreState["tables"][number],
    { kind: "analysis" | "workflow" }
  >;
}

export const DataTableComputeCredits = ({
  selectedTable,
}: DataTableComputeCreditsProps) => {
  const usedCredits = (() => {
    switch (selectedTable.kind) {
      case "analysis": {
        // Exclude cached rows in sum of used credits since tenant isn't charged for them
        return selectedTable.rows
          .filter((row) => !row.cached)
          .reduce((acc, row) => acc + (row.task?.credits ?? 0), 0);
      }
      case "workflow": {
        // Run credits already exclude cached steps
        return selectedTable.rows.reduce(
          (acc, row) => acc + (row.run?.credits ?? 0),
          0,
        );
      }
    }
  })();

  const totalUsedCredits = roundToSignificant(usedCredits);

  return (
    <Tooltip
      content={
        <>
          <div>{totalUsedCredits} compute credits used</div>
        </>
      }
    >
      <EuiFlexGroup responsive={false} alignItems="center" gutterSize="xs">
        <EuiFlexItem grow={false}>
          <EuiIcon type="compute" color="subdued" />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiText size="s" color="subdued">
            {totalUsedCredits}
          </EuiText>
        </EuiFlexItem>
      </EuiFlexGroup>
    </Tooltip>
  );
};
